import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login';
import PrimoAccesso from './pages/PrimoAccesso';

// Admin Pages
import DashboardAdmin from './pages/admin/Dashboard';
import Clienti from './pages/admin/Clienti';
import ClienteDettaglio from './pages/admin/ClienteDettaglio';
import Abbonamenti from './pages/admin/Abbonamenti';
import AbbonamentoDettaglio from './pages/admin/AbbonamentoDettaglio';
import Linee from './pages/admin/Linee';
import LineaDettaglio from './pages/admin/LineaDettaglio';
import Pullman from './pages/admin/Pullman';
import Pagamenti from './pages/admin/Pagamenti';
import PagamentoDettaglio from './pages/admin/PagamentoDettaglio';
import Autisti from './pages/admin/Autisti';
import StoricoCorse from './pages/admin/StoricoCorse';
import TesseriniCondivisi from './pages/admin/TesseriniCondivisi';
import Preventivi from './pages/admin/Preventivi';
import PreventivoDettaglio from './pages/admin/PreventivoDettaglio';
import Committenti from './pages/admin/Committenti';
import SelezioneArea from './pages/admin/SelezioneArea';
import AutostaDettaglio from './pages/admin/AutostaDettaglio';
import Report from './pages/admin/Report';
import Impostazioni from './pages/admin/Impostazioni';
import Eventi from './pages/admin/Eventi';
import EventoDettaglio from './pages/admin/EventoDettaglio';
import OrdiniEventi from './pages/admin/OrdiniEventi';
import ClientiEventi from './pages/admin/ClientiEventi';
import ImpostazioniEventi from './pages/admin/ImpostazioniEventi';

// Other Dashboards
import DashboardAutista from './pages/autista/Dashboard';
import DashboardUtente from './pages/utente/Dashboard';

import ProtectedRoute from './components/shared/ProtectedRoute';
import authStore from './store/authStore';

function App() {
  const { utente } = authStore();

  // Redirect dopo login in base al ruolo
  const getDashboardRoute = () => {
    if (!utente) return '/login';
    
    switch (utente.ruolo) {
      case 'SOLA_LETTURA':
      case 'ADMIN':
        // Si entra dalla scelta dell'area, non più dal cruscotto scolastico
        return '/admin';
      case 'AUTISTA':
        return '/autista/dashboard';
      case 'UTENTE':
        return '/utente/dashboard';
      default:
        return '/login';
    }
  };

  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/primo-accesso" element={<PrimoAccesso />} />
        
        {/* Admin Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <SelezioneArea />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <DashboardAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/clienti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Clienti />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/clienti/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <ClienteDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/abbonamenti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Abbonamenti />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/abbonamenti/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <AbbonamentoDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/linee"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Linee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/linee/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <LineaDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/storico-corse"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <StoricoCorse />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/tesserini-condivisi"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <TesseriniCondivisi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/preventivi"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Preventivi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/preventivi/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <PreventivoDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/committenti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Committenti />
            </ProtectedRoute>
          }
        />

        {/* Navette eventi. Il dettaglio sta sopra l'elenco perche'
            /admin/eventi/nuovo deve colpire il dettaglio, non l'elenco. */}
        <Route
          path="/admin/eventi/ordini"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <OrdiniEventi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/eventi/clienti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <ClientiEventi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/eventi/impostazioni"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <ImpostazioniEventi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/eventi/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <EventoDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/eventi"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Eventi />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pullman"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN']}>
              <Pullman />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pagamenti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Pagamenti />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pagamenti/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <PagamentoDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/autisti"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Autisti />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/autisti/:id"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <AutostaDettaglio />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/report"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN']}>
              <Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/impostazioni"
          element={
            <ProtectedRoute ruoliConsentiti={['ADMIN', 'SOLA_LETTURA']}>
              <Impostazioni />
            </ProtectedRoute>
          }
        />
        
        {/* Autista Routes */}
        <Route
          path="/autista/dashboard"
          element={
            <ProtectedRoute ruoliConsentiti={['AUTISTA']}>
              <DashboardAutista />
            </ProtectedRoute>
          }
        />
        
        {/* Utente Routes */}
        <Route
          path="/utente/dashboard"
          element={
            <ProtectedRoute ruoliConsentiti={['UTENTE']}>
              <DashboardUtente />
            </ProtectedRoute>
          }
        />
        
        <Route path="/" element={<Navigate to={getDashboardRoute()} replace />} />
        <Route path="*" element={<Navigate to={getDashboardRoute()} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
